import { ExpandableSection, Flex, smBumps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useExpandableSectionConfig } from '../../../hooks/adjustments/expandableSection'
import { useQuoteData } from '../../../hooks/adjustments/quote'
import {
  tDefaults,
  TKeyBuilder,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { useAdjustments } from '../../../state'
import { QuoteManagementConfig } from '../../../state/configuration'
import { FormFormatter } from '../../formBuilder'

export const QuoteSummary: FunctionComponent<{
  config: QuoteManagementConfig
  quote: Quote
  tKey: TKeyBuilder
}> = ({ config, quote, tKey }) => {
  const { t } = useWriskTranslation()
  const { getAdjustment } = useAdjustments()

  const toData = useQuoteData(quote)

  const [header, inputs] = useExpandableSectionConfig({
    sectionId: config.id,
    form: config.form,
    tKey,
    toData,
  })

  const sectionHeader = (
    <Flex flexDirection='column' alignItems='flex-start' gap={2}>
      <Typo typoSize='base' color='bodySecondary'>
        {t(tKey('titles', config.id))}
      </Typo>
      <Typo typoSize='md' fontWeight='bold'>
        {header}
      </Typo>
    </Flex>
  )

  const expandedComponents = inputs.map((input) => {
    const adjustment = getAdjustment(input.name)

    return (
      <Flex
        key={input.name}
        px={smBumps}
        py={2}
        flexDirection='column'
        alignItems='flex-start'
      >
        <Typo typoSize='xs' color='bodySecondary' mb={1}>
          {t(tDefaults('product.headers', input.name))}
        </Typo>
        <Typo as='pre'>
          <FormFormatter input={input} value={toData(adjustment)} t={t} />
        </Typo>
      </Flex>
    )
  })

  return (
    <ExpandableSection reversed header={sectionHeader}>
      {expandedComponents}
    </ExpandableSection>
  )
}
